import { gql } from '@apollo/client'
import { head } from 'ramda'
import React from 'react'

import { generalClient } from '../../../../../utils/apollo/api'
import { useModalData } from '../../../../../components/modals/ModalsContext'
import { useQuery } from '../../../../../utils/apollo/_helpers/useQuery'
import StatePresenter from '../../../../../components/helpers/StatePresenter'

const Context = React.createContext([])
const { Provider } = Context
export const useConfigState = () => React.useContext(Context)
export const useConfig = () => useConfigState()?.config

const QUERY = gql`
  query Config($id: Int) {
    config(id: $id) {
      id
      name
      value
      updatedAt
      insertedAt
    }
  }
`

const ConfigLoader = ({ children }) => {
  const { id } = useModalData() || {}

  const { data, ...state } = useQuery(QUERY, {
    variables: { id: id },
    skip: !id,
    client: generalClient,
    fetchPolicy: 'no-cache'
  })

  return (
    <StatePresenter {...state} empty={false}>
      <Provider value={data}>{children}</Provider>
    </StatePresenter>
  )
}

export default ConfigLoader
